<template>
  <span class="px-3">
    <EditOnClick v-model="value" type="price" :editable="row.editable" />
    <button
      class="btn btn-secondary btn-sm"
      :title="$t(`receiveMoney.receiveMoney`)"
      v-on:click="show"
    >
      <BaseIcon name="money-recive" />
    </button>
  </span>
</template>
<script>
import { defineAsyncComponent } from "vue";
import EditOnClick from "@/components/inputs/EditOnClick";
const BaseIcon = defineAsyncComponent(() => import("../../icons/BaseIcon.vue"));

export default {
  name: "ReceiveMoney",
  components: { EditOnClick, BaseIcon },
  props: {
    id: Number,
    type: String,
    row: Object,
    modelValue: Object,
  },
  data() {
    return {
      value: this.modelValue,
    };
  },
  watch: {
    value() {
      this.$emit("update:modelValue", this.value);
      this.$emit("change");
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  methods: {
    show() {
      window.apps.callEvent("modal:receiveMoney", this.id);
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>
